import { FC, useRef, useState } from 'react';
import { css } from '@linaria/core';
import { FilePreview } from './ChatInput';
interface ImagePreviewProps {
  images: FilePreview[];
}
export const ImagePreview: FC<ImagePreviewProps> = ({
  images
}) => {
  const [focusedImage, setFocusedImage] = useState<FilePreview>();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const openDialog = () => {
    if (dialogRef.current) dialogRef.current.showModal();
  };
  const closeDialog = () => {
    if (dialogRef.current) dialogRef.current.close();
  };
  const handleImageSelect = (selectedImage: FilePreview) => {
    setFocusedImage(selectedImage);
    openDialog();
  };
  return <>
      <div className={imagePreviewContainer}>
        {images.map(each => {
        const onClick = () => handleImageSelect(each);
        return <div className={imagePreviewWrapper} key={each.file.name}>
              {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
              <img src={each.preview} className={imagePreview} alt={each.file.name} onClick={onClick} />
            </div>;
      })}
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
      <dialog ref={dialogRef} className={imageDialog} onClick={closeDialog}>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
        <img src={focusedImage?.preview} alt={focusedImage?.file.name} className={dialogImage} onClick={e => e.stopPropagation()} // Prevent closing on image click
      />
      </dialog>
    </>;
};
const imagePreviewContainer = "odules__Playground__Components__ImagePreview_tsx-imagePreviewContainer-iup9r0h";
const imagePreviewWrapper = "odules__Playground__Components__ImagePreview_tsx-imagePreviewWrapper-i1fs5o3r";
const imagePreview = "odules__Playground__Components__ImagePreview_tsx-imagePreview-ilf49d8";
const imageDialog = "odules__Playground__Components__ImagePreview_tsx-imageDialog-iqv3i2k";
const dialogImage = "odules__Playground__Components__ImagePreview_tsx-dialogImage-d1tf0tt3";

require("./ImagePreview.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ImagePreview.tsx");